import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export function AlertsBell({ dark = false }) {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => api.get("/alerts").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const onOpen = (o) => { if (o && data.unread) api.post("/alerts/read-all").then(() => setData({ ...data, unread: 0 })); };
  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button className={`relative grid h-9 w-9 place-items-center rounded-full transition-colors ${dark ? "text-emerald-100 hover:bg-white/10" : "text-[#0F382C] hover:bg-black/5"}`} data-testid="alerts-bell">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && <span className="absolute -right-0.5 -top-0.5 grid h-5 min-w-[20px] place-items-center rounded-full bg-[#D96B43] px-1 text-[10px] font-bold text-white" data-testid="alerts-unread-count">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-0" data-testid="alerts-popover">
        <div className="border-b px-4 py-3 font-display font-semibold text-[#0F382C]">Alerts</div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 && <div className="p-4 text-sm text-muted-foreground">No alerts yet.</div>}
          {data.items.map((a) => (
            <div key={a.id} className={`border-b px-4 py-3 text-sm ${a.read ? "" : "bg-rose-50/60"}`} data-testid={`alert-${a.id}`}>
              <div>{a.message}</div><div className="text-xs text-muted-foreground mt-1">{fmtDateTime(a.created_at)}</div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
